import { useState, useContext, useEffect } from "react";
import { Accordion, Row, Col, Card} from "react-bootstrap";
import { AnimatedIconButton } from "components/MiCuenta/AnimatedIconButton/AnimatedIconButton";
import ToolTip from "components/ToolTip/ToolTip";
import { SvgComponent } from "components";
import { CountContext } from "contexts";
import IconButton from "components/IconButton/IconButton";

export function InformationSection({
    title,
    children,    
}) {
    
    let countContext = null;
    try {
        countContext = useContext(CountContext);
        
    } catch (error) {
        
    }
    
    const { count, setCount } = countContext || {};
    const [isExpanded, setIsExpanded] = useState(false);
    
    const handleToggle = () => {
        setIsExpanded(!isExpanded);
    };

    let componentCount = count ? `(${count})` : "";

    return (
        <div style={{ marginBottom: '20px', border: '1px solid #dee2e6', borderRadius: '0.375rem' }}>
            <div 
                onClick={handleToggle}
                style={{ 
                    padding: '1rem',
                    cursor: 'pointer',
                    backgroundColor: '#f8f9fa',
                    borderBottom: isExpanded ? '1px solid #dee2e6' : 'none'
                }}
            >
                <h5 style={{
                    fontSize: "2vh",
                    fontWeight: "bold",
                    cursor: "pointer",
                    margin: 0,
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    <span style={{ marginRight: '10px' }}>
                        {isExpanded ? '▼' : '▶'}
                    </span>
                    {title} {componentCount}
                </h5>
            </div>
            
            {isExpanded && (
                <div style={{ padding: '1rem' }}>
                    {children}
                </div>
            )}
        </div>
    );
}

export default InformationSection;